module.exports = __webpack_public_path__ + "static/collaboration-section-account-35d0eb4847681b68bca6a6ad0d701665.png";